<template>
    <button class="btn" :class="classes" @click="$emit('click')" :type="type" :disabled="loading || disabled">
        <span :class="{ 'me-1': $slots.default }" v-if="loading || icon">
            <Spinner v-if="loading" />
            <Icon :icon="icon" v-else-if="icon" />
        </span>
        <slot></slot>
    </button>
</template>

<script>
    import Icon from '../Icons/Icon'
    import Spinner from '../Loaders/Spinner'

    export default {
        name: 'Button',
        components: {
            Icon,
            Spinner
        },
        props: {
            large: {
                type: Boolean,
                default: false
            },
            small: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'button'
            },
            icon: [ String, Array ],
            color: {
                type: String,
                default: 'primary',
                validator: function (value) {
                    return ['primary', 'primary-alt', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'white', 'dark'].includes(value)
                }
            },
            loading: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            classes: function() {
                return {
                    'btn-success': this.color === 'success',
                    'btn-warning': this.color === 'warning',
                    'btn-danger': this.color === 'danger',
                    'btn-info': this.color === 'info',
                    'btn-primary': this.color === 'primary',
                    'btn-primary-alt': this.color === 'primary-alt',
                    'btn-secondary': this.color === 'secondary',
                    'btn-light': this.color === 'light',
                    'btn-white': this.color === 'white',
                    'btn-dark': this.color === 'dark',
                    'btn-lg': this.large,
                    'btn-sm': this.small
                }
            }
        }
    }
</script>
